<template>
    <div class="brand">
        <van-grid :column-num="5" icon-size="36">
            <van-grid-item v-for="(itm, idx) in brands" :icon="itm.img" :key="idx" @click="pickBrand(itm)" class="{ curBrand.id==itm.id:'sel' }" />
        </van-grid>
        <van-grid :column-num="3" v-if="false">
            <van-grid-item v-for="(itm, idx) in series" :key="idx" :text="itm.name" @click="pickSeries(itm)" class="{ curSeries.id==itm.id: 'sel' }" />
        </van-grid>
    </div>
</template>

<script>
import { 
    Grid,
    GridItem,
    Image,
    Row,
    Col,
    Icon, 
    Loading, 
    List
} from 'vant'

import { UsedCarShopStyleApi } from '@/api/usedcar'

export default {
    name: 'BrandSeries',
    components: {
        [Icon.name]: Icon,
        [Loading.name]: Loading,
        [List.name]: List,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
        [Image.name]: Image,
        [Row.name]: Row,
        [Col.name]: Col
    },
    data() {
        return {
            data: [], // 所有类别数据
            curBrand: this.getDefault(),
            curSeries: this.getDefault()
        }
    },
    computed: {
        brands() {
            let tmp = [this.getDefault()]
            this.data.forEach(it => {
                if (tmp.indexOf(it['brand']) == -1) {
                    tmp.push({ id: it['brand'], name: it['brand_name'], img: it['img_url'] })
                }
            })
            return tmp
        },
        series() {
            let tmp = [this.getDefault()]
            this.data.forEach(it => {
                if (tmp.indexOf(it['series']) == -1) {
                    tmp.push({ id: it['series'], name: it['series_name'] })
                }
            })
            return tmp
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            var that = this
            this.axios.get(UsedCarShopStyleApi, { }).then((ret) => {
                console.log('UsedCarShopStyleApi')
                console.log(ret)
                that.data = ret
            })
        },
        pickBrand(obj) {
            this.curBrand = obj
            this.curSeries = this.getDefault()
            this.$emit('pick', { brand: this.curBrand.id, series: 0 })
        },
        pickSeries(obj) {
            this.curSeries = obj
            this.$emit('pick', { brand: this.curBrand.id, series: this.curSeries.id })
        },
        getDefault() {
            return { id: 0, name: '全部', img: 'https://public.qiniu.xcims.com/carbrand_all.png'}
        }
    }
}
</script>

<style lang="less" scoped>
    .brand {
        .sel {
            background-color: #409EFF;
        }
        .unsel {
            background-color: #c2d2e2;
        }
    }
</style>

<style lang="less">
.brand {
    .van-icon__image {
        width:1.5em;
        height:1.5em;
    }
}
</style>